<script>
import { Duration, DateTime } from 'luxon'
import { HeartIcon, CurrencyDollarIcon, EnvelopeIcon } from '@heroicons/vue/24/outline'
import TwButton from '@/components/generic/tw-button.vue'
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import TwTimeLeft from '@/components/generic/tw-time-left.vue'
import DonationsListGroup from '@/components/donations/public/donations-list-group.vue'
import FundraiserRaisedAmount from '@/components/fundraisers/fundraiser-raised-amount.vue'
import FundraiserActions from '@/components/fundraisers/public/fundraiser-actions.vue'
import FundraiserPageSelectorPublic from '@/components/fundraiser-pages/fundraiser-page-selector-public.vue'

export default {
  name: 'FundraiserRightColumn',
  components: { FundraiserActions, FundraiserRaisedAmount, DonationsListGroup, TwTimeLeft, TwProgressBar, TwButton, HeartIcon, CurrencyDollarIcon, FundraiserPageSelectorPublic },
  props: {
    fundraiser: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ShowStickyBottomActions: false,
      DonateToFundraiserPage: null,
    };
  },
  computed: {
    fundraiserDeadlineDays () {
      const color = '#f3f3f4'
      return Math.round(DateTime.fromISO(this.fundraiser.deadline).diffNow('days').days)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 600) { // Adjust scroll threshold as needed
        this.ShowStickyBottomActions = true;
      } else {
        this.ShowStickyBottomActions = false;
      }
    },
  },
}
</script>

<template>
  <div class="lg:rounded-2xl lg:shadow-sm lg:bg-white p-0 lg:p-6">
    <div v-if="fundraiser.cached">
      <fundraiser-raised-amount v-if="fundraiser.settings?.show_raised_amount_instead_of_goal === true || fundraiser.settings?.goal_hidden !== true" :fundraiser="fundraiser" />
      <tw-progress-bar v-if="fundraiser.settings?.goal_hidden !== true" :progress="fundraiser.cached.percentage_raised" />
      <tw-time-left v-if="fundraiser.deadline" class=" text-gray-600 text-sm" :deadline="fundraiser.deadline" detailed />
      <fundraiser-actions :fundraiser="fundraiser" />
    </div>
    <donations-list-group :fundraiser="fundraiser" class="mt-8 hidden lg:block" />
    <div class="hidden lg:static">
      <div v-if="fundraiser.cached" class="uppercase">
        <heart-icon class="h-4 inline" /> Organizer: {{ fundraiser.cached.organizer_name }}
      </div>
      <div v-if="fundraiser.cached" class="uppercase">
        <currency-dollar-icon class="h-4 inline" /> Beneficiary: {{ fundraiser.cached.beneficiary_name }}
      </div>
    </div>
    <div v-show="ShowStickyBottomActions" class="mobile-donation-box border border-gray-100 shadow-md rounded-2xl bg-white p-4 lg:hidden">
      <fundraiser-raised-amount v-if="fundraiser.settings?.show_raised_amount_instead_of_goal === true || fundraiser.settings?.goal_hidden !== true" :fundraiser="fundraiser" />
      <tw-progress-bar v-if="fundraiser.settings?.goal_hidden !== true" :progress="fundraiser.cached.percentage_raised" />
      <fundraiser-actions :fundraiser="fundraiser" minimal />
    </div>
  </div>
</template>

<style scoped>

</style>
